"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toQueryString = toQueryString;
const constants_1 = require("./constants");
/**
 * @param tokens - Array of [name, value] tuples to build the request earn key
 * @returns query string sorted by the predefined order
 */
function buildEarnKey(tokens) {
    const filteredTokens = tokens.filter(([, value]) => value && value.trim() !== '');
    // Convert tokens to key-value pairs and sort by predefined order
    const keyValuePairs = filteredTokens.map(([key, value]) => ({ key, value }));
    keyValuePairs.sort((a, b) => {
        const indexA = constants_1.sortOrder.indexOf(a.key);
        const indexB = constants_1.sortOrder.indexOf(b.key);
        // If both keys are in sortOrder, sort by their position
        if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB;
        }
        // If only one key is in sortOrder, prioritize it
        if (indexA !== -1)
            return -1;
        if (indexB !== -1)
            return 1;
        // If neither key is in sortOrder, maintain original order
        return 0;
    });
    return toQueryString(keyValuePairs);
}
/**
 * Converts KeyValuePair array to query string format (compatible with older Node.js)
 * @param keyValuePairs - Array of key-value pairs
 * @returns Query string format
 */
function toQueryString(keyValuePairs) {
    return keyValuePairs
        .map(({ key, value }) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
}
exports.default = buildEarnKey;
